import { Inject } from '@odinjs/odin';
import { ModalService, TextAreaAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { DialogType, ModalType, SimpleDialogParams } from '../../../interfaces/simple-dialog';
import { FragmentNames, RespiratoryMonitoringInactivateAliases } from '../../../codegen';
import { Endpoint } from '../../../constants/endpoints';
import BaseController from '../../BaseController';
import { SimpleDialog } from '../../dialog-helper';

@Controller({ fragment: FragmentNames.RESPIRATORY_MONITORING_INACTIVATE })
class RespiratoryMonitoringInactivateController extends BaseController {

  @Inject(RespiratoryMonitoringInactivateAliases.TEXT_AREA_RESPIRATORY_MONITORING)
  justificationTextAreaApi!: TextAreaAPI;

  inactivate() : void {
    const { sequenceNumber, patientId, encounterId } = this.historyService.getCurrentRouteParams();
    const justification = this.justificationTextAreaApi.getValue();

    HttpService.put(Endpoint.RESPIRATORY_MONITORING_INACTIVATE,
      { encounterId, justification, patientId, sequenceNumber }).then(response => {
      if (response.status === 200 && response.body) {
        applicationContext.popNavigationItem();
        applicationContext.popNavigationItem();
        this.showMessageDialog('title.disable-record', 'patient-evolution.successfully-inactivated-message')
      }
    });
  }

  showMessageDialog(title: string, description: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: (): void => ModalService.close(FragmentNames.RESPIRATORY_MONITORING_INACTIVATE),
      titleDialog: title,
      titleOnOk: 'OK',
    }
    SimpleDialog.openDialog(dialogParams);
  }

  @OnCancel({ target: RespiratoryMonitoringInactivateAliases.FORM_RESPIRATORY_MONITORING_INACTIVATE })
  onCancelForm(): void {
    ModalService.close(FragmentNames.RESPIRATORY_MONITORING_INACTIVATE);
  }

  @OnBeforeSubmit({ target: RespiratoryMonitoringInactivateAliases.FORM_RESPIRATORY_MONITORING_INACTIVATE })
  onBeforeSubmitForm(): void {
    this.inactivate();
  }
}

export default RespiratoryMonitoringInactivateController;